import moment from "moment";

/**
 * 
 * @param {*} period 
 * @param {*} effectiveRanges 
 * @param {*} seasonScope 
 */
export function isPeriodInEffectiveRanges(period, effectiveRanges, seasonScope, useFederalScopeOverride) {
	if(!effectiveRanges?.length) {
		return false;
	}
	for(const range of effectiveRanges) {
		if(
			moment(range.Start).isSameOrAfter(period.EndExclusive)
			|| (range.End !== undefined && moment(range.End).isSameOrBefore(period.BeginInclusive))
			|| seasonScope !== (useFederalScopeOverride ? "FED" : range.Scope)
		) {
			continue;
		} else {
			return true;
		}
	}
	return false;
}